export enum CinemaContentUpcomingScopeEnum {
    UNSCHEDULED = 'unscheduled'
}
